import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/teaser_kundenbewertungen.jpg")